/* global talkus */

function addTalkus(user) {
  const isWeekend = new Date().getDay() % 6 === 0;
  if (!isWeekend) {
    (function(t, a, l, k, u, s, e) {
      if (!t[u]) {
        (t[u] = function() {
          (t[u].q = t[u].q || []).push(arguments);
        }),
          (t[u].l = 1 * new Date());
        (s = a.createElement(l)), (e = a.getElementsByTagName(l)[0]);
        s.async = 1;
        s.src = k;
        e.parentNode.insertBefore(s, e);
      }
    })(window, document, "script", "//www.talkus.io/plugin.beta.js", "talkus");

    talkus("primaryColor", "#00b4ff", "#ffffff");
    talkus(
      "loadingImage",
      "https://platform.sh/themes/custom/platformsh/images/favicon.png"
    );

    if (user != undefined) {
      var project_list = "";
      if (user.projects) {
        user.projects.forEach(function(value) {
          project_list += value.name + ":\n" + value.uri + "\n";
        });
      }

      talkus("init", "GRDz2pBK6TTTTkyFT", {
        id: user.uuid,
        name: user.label,
        accounts_url: "https://accounts.platform.sh/user/" + user.id,
        projects: project_list
      });
    } else {
      talkus("init", "GRDz2pBK6TTTTkyFT");
    }
  }
}

export default addTalkus;



// WEBPACK FOOTER //
// ./src/talkus.js